import { motion } from "framer-motion";
import { LOGO_PATHS } from "../assets/logoPaths";

// The Social Wavez monogram, traced to SVG from the brand logo.
// animated=true draws the waves stroke-by-stroke, then fills them in.
export const LogoMark = ({ size = 40, animated = false, className = "" }) => (
  <svg
    viewBox="-3 -3 170 167"
    width={size}
    height={(size * 167) / 170}
    className={className}
    role="img"
    aria-label="Social Wavez logo mark"
  >
    {LOGO_PATHS.map((p, i) =>
      animated ? (
        <motion.path
          key={i}
          d={p.d}
          transform={p.transform || undefined}
          fill={p.fill}
          stroke={p.fill}
          strokeWidth="1.2"
          initial={{ pathLength: 0, fillOpacity: 0 }}
          animate={{ pathLength: 1, fillOpacity: 1 }}
          transition={{
            pathLength: { duration: 0.9, delay: 0.1 + i * 0.1, ease: "easeInOut" },
            fillOpacity: { duration: 0.45, delay: 0.55 + i * 0.1 },
          }}
        />
      ) : (
        <path key={i} d={p.d} transform={p.transform || undefined} fill={p.fill} />
      ),
    )}
  </svg>
);

export const Logo = ({ size = 38, animated = false, stacked = false, className = "" }) => (
  <span
    className={`inline-flex ${stacked ? "flex-col items-center" : "items-center gap-3"} ${className}`}
  >
    <LogoMark size={size} animated={animated} />
    <span className={stacked ? "mt-3 text-center" : "leading-none"}>
      <span
        className="block bg-gradient-to-r from-[#3CBE6E] via-[#8FAF4E] to-[#E3C65F] bg-clip-text font-display font-bold uppercase tracking-[0.2em] text-transparent"
        style={{ fontSize: size * 0.42 }}
      >
        Social Wavez
      </span>
      <span
        className="mt-1 block font-medium uppercase tracking-[0.42em] text-white/50"
        style={{ fontSize: Math.max(9, Math.round(size * 0.24)) }}
      >
        Technologies
      </span>
    </span>
  </span>
);
